import React from 'react';
import { Box, Dialog, DialogContent, IconButton, Typography, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { fmtDate, groupBySite, isOnDay, isUnassigned } from '../projectSchedule.utils';
import { SiteTaskGroup } from './DayListView';

// Every sub-task on one day, grouped by site. Opened from a month-grid cell or a team-board block.
export default function DayTasksDialog({ ymd, tasks, visits, onClose, onOpenTask }) {
    const fullScreen = useMediaQuery('(max-width:700px)');
    if (!ymd) return null;

    const dayTasks = tasks.filter(t => isOnDay(t, ymd));
    const groups = groupBySite(dayTasks);
    const engineers = new Set(dayTasks.filter(t => !isUnassigned(t)).map(t => t.spoc.id || t.spoc.name)).size;
    const unassigned = dayTasks.filter(isUnassigned).length;

    return (
        <Dialog open onClose={onClose} fullWidth maxWidth="sm" fullScreen={fullScreen} PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 4 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', px: 2.25, py: 1.75, bgcolor: '#fafbfc' }}>
                <Typography sx={{ fontWeight: 700, flex: 1 }}>{fmtDate(ymd, 'dddd D MMMM')}</Typography>
                <IconButton size="small" onClick={onClose} aria-label="Close"><CloseIcon /></IconButton>
            </Box>
            <DialogContent sx={{ pt: 1.5 }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px 12px', color: '#6b7785', fontSize: '13.5px', mb: 1.5 }}>
                    <span>{dayTasks.length} sub-task{dayTasks.length === 1 ? '' : 's'}</span>
                    <span>{groups.length} site{groups.length === 1 ? '' : 's'}</span>
                    <span>{engineers} engineer{engineers === 1 ? '' : 's'}</span>
                    {unassigned > 0 && <span style={{ color: '#dc2626', fontWeight: 700 }}>{unassigned} unassigned</span>}
                </Box>
                {groups.length
                    ? groups.map(g => <SiteTaskGroup key={g.facility_id} group={g} ymd={ymd} onOpen={onOpenTask} visits={visits} />)
                    : <Typography sx={{ color: '#6b7785' }}>Nothing scheduled.</Typography>}
            </DialogContent>
        </Dialog>
    );
}
